import { render, staticRenderFns } from "./BlockIE.vue?vue&type=template&id=8eff84d8&"
import script from "./BlockIE.vue?vue&type=script&lang=js&"
export * from "./BlockIE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports